import React from "react";
import { Button, Box } from "@mui/material";
import { perkQuirkLikeLabel, perkQuirkDislikeLabel } from "./util";
import { LikeIcon } from "../../icons/LikeIcon";
import { DislikeIcon } from "../../icons/DislikeIcon";
import type {
  PerkQuirkSentimentValue,
  PerkQuirkSentimentRecord,
} from "../../../types";

interface PerkQuirkItem {
  id: string;
  type?: string;
}

interface PerksQuirksSentimentProps {
  perkQuirk: PerkQuirkItem;
  reason: string;
  onRated?: (perksQuirksId: string, sentiment: PerkQuirkSentimentValue) => void;
  sentiments?: PerkQuirkSentimentRecord[];
  onSentimentChange?: (
    perksQuirksId: string,
    sentiment: PerkQuirkSentimentValue,
  ) => void;
}

export const PerksQuirksSentiment = ({
  perkQuirk,
  onRated,
  sentiments = [],
  onSentimentChange,
}: PerksQuirksSentimentProps) => {
  const perksQuirksId = perkQuirk.id;
  const type = perkQuirk.type;

  const currentSentiment = sentiments.find(
    (s) => String(s.perksQuirksId) === String(perksQuirksId),
  );

  const handleSentimentClick = (sentiment: PerkQuirkSentimentValue) => {
    if (onRated) {
      onRated(perksQuirksId, sentiment);
    }
    if (onSentimentChange) {
      onSentimentChange(perksQuirksId, sentiment);
    }
  };

  return (
    <Box
      sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}
    >
      <Button
        startIcon={<LikeIcon />}
        onClick={() => handleSentimentClick("LIKE")}
        color="primary"
        variant={
          currentSentiment?.sentiment === "LIKE" ? "contained" : "outlined"
        }
      >
        {perkQuirkLikeLabel(type)}
      </Button>
      <Button
        startIcon={<DislikeIcon />}
        onClick={() => handleSentimentClick("DISLIKE")}
        color="primary"
        variant={
          currentSentiment?.sentiment === "DISLIKE" ? "contained" : "outlined"
        }
      >
        {perkQuirkDislikeLabel(type)}
      </Button>
    </Box>
  );
};
